"use client";

import Image from "next/image";
import { cn } from "@/lib/utils";

type BrandLogoProps = {
  className?: string;
  /** Use true only for the main nav logo (LCP). */
  priority?: boolean;
};

/** Light UI: `logo-dark.svg`. Dark UI: `logo-white.svg` (`html.dark` from ThemeToggle). */
export function BrandLogo({ className, priority = false }: BrandLogoProps) {
  return (
    <span
      className={cn(
        "relative inline-block h-8 w-[7.25rem] shrink-0 sm:h-9 sm:w-[8.25rem]",
        className
      )}
    >
      <Image
        src="/logo-dark.svg"
        alt="Proslava.ba"
        fill
        sizes="132px"
        className="object-contain object-left dark:hidden"
        priority={priority}
      />
      <Image
        src="/logo-white.svg"
        alt=""
        aria-hidden
        fill
        sizes="132px"
        className="hidden object-contain object-left dark:block"
        priority={priority}
      />
    </span>
  );
}
